import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *抢答学生列表
 * @param params
 * 
*/

export const answerList = params => Http.get(`${baseUrl}/activity/answer`, { params })

/**
 *抢答
 * @param activityId
 * 
*/

export const answer = activityId => Http.post(`${baseUrl}/activity/answer/${activityId}` )

/**
 *抢答信息
 * @param activityId 
 * 
*/

export const answerInfo = activityId => Http.get(`${baseUrl}/activity/answer/${activityId}/info` )
